export default __webpack_public_path__ + "static/media/popup plan 2.f96529c4.png";